/**
 * @generated SignedSource<<763bda75075304e73b76801c913cf0a1>>
 * @relayHash 5c2cdeb12ef15e512b6d4893d64d49cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fee9d85147999b288c7b6799305a27290d05b82c11ac443c355d44c0618f0c7d

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forgeExtensionRenderingContext"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "uiModificationsContext"
    }],
    v1 = {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    v2 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v3 = {
      "kind": "ScalarField",
      "name": "type"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "rootUiModificationsQuery",
      "selections": [{
        "args": [v1 /*: any*/, {
          "kind": "Variable",
          "name": "forgeExtensionRenderingContext",
          "variableName": "forgeExtensionRenderingContext"
        }, {
          "kind": "Variable",
          "name": "uiModificationsContext",
          "variableName": "uiModificationsContext"
        }],
        "kind": "FragmentSpread",
        "name": "fragment_AtlassianUiModificationsCore_RootFragment"
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "rootUiModificationsQuery",
      "selections": [{
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [{
          "args": [{
            "kind": "Variable",
            "name": "context",
            "variableName": "uiModificationsContext"
          }],
          "concreteType": "JiraAppUiModifications",
          "kind": "LinkedField",
          "name": "uiModifications",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "name": "appEnvId"
          }, {
            "concreteType": "JiraUiModification",
            "kind": "LinkedField",
            "name": "uiModifications",
            "plural": true,
            "selections": [v2 /*: any*/, {
              "kind": "ScalarField",
              "name": "data"
            }]
          }]
        }, {
          "concreteType": "JiraForgeQuery",
          "kind": "LinkedField",
          "name": "forge",
          "plural": false,
          "selections": [{
            "alias": "uiModificationsExtensions",
            "args": [v1 /*: any*/, {
              "kind": "Variable",
              "name": "context",
              "variableName": "forgeExtensionRenderingContext"
            }, {
              "kind": "Literal",
              "name": "types",
              "value": ["jira:uiModifications"]
            }],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [v2 /*: any*/, {
              "kind": "ScalarField",
              "name": "appVersion"
            }, {
              "kind": "ScalarField",
              "name": "installationId"
            }, {
              "kind": "ScalarField",
              "name": "environmentId"
            }, {
              "kind": "ScalarField",
              "name": "environmentType"
            }, {
              "kind": "ScalarField",
              "name": "environmentKey"
            }, {
              "concreteType": "JiraForgeExtensionLicense",
              "kind": "LinkedField",
              "name": "license",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "active"
              }, v3 /*: any*/, {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
              }, {
                "kind": "ScalarField",
                "name": "trialEndDate"
              }, {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
              }, {
                "kind": "ScalarField",
                "name": "isEvaluation"
              }, {
                "kind": "ScalarField",
                "name": "billingPeriod"
              }, {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
              }, {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
              }, {
                "kind": "ScalarField",
                "name": "capabilitySet"
              }]
            }, {
              "kind": "ScalarField",
              "name": "properties"
            }, {
              "kind": "ScalarField",
              "name": "scopes"
            }, v3 /*: any*/, {
              "concreteType": "JiraForgeAppEgressDeclaration",
              "kind": "LinkedField",
              "name": "egress",
              "plural": true,
              "selections": [v3 /*: any*/, {
                "kind": "ScalarField",
                "name": "addresses"
              }]
            }, {
              "kind": "ScalarField",
              "name": "consentUrl"
            }, {
              "concreteType": "JiraUserAppAccess",
              "kind": "LinkedField",
              "name": "userAccess",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "hasAccess"
              }]
            }, {
              "kind": "ScalarField",
              "name": "hiddenBy"
            }]
          }]
        }]
      }]
    },
    "params": {
      "id": "fee9d85147999b288c7b6799305a27290d05b82c11ac443c355d44c0618f0c7d",
      "metadata": {},
      "name": "rootUiModificationsQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "9036ea3b10c5003976e51018f89bdc35";
export default node;